import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { FaChevronRight } from 'react-icons/fa';

import {
  propTypesIllustration,
  propTypesLink,
  propTypesUTMs,
} from '../../../../constants/Proptypes';

import Picture from '../../../../../ui/Atoms/Picture';

import { getUrlWithUTMs } from '../../../../utils/getUTM';

import * as S from './CardCTA.styles';

export const CardCTA = ({ item, index, utms }) => {
  const {
    horizontal_card_cta_datatrack: dataTrackAttribute,
    horizontal_card_cta_label: label,
    horizontal_card_cta_link: { id: documentID, url, target },
    horizontal_card_illustration: { alt },
    horizontal_card_title: cardTitle,
    horizontal_card_description: cardDescription,
  } = item || '';
  const CardCTAWrapper = documentID ? S.CardCTAInternal : S.CardCTA;

  const image = getImage(item.horizontal_card_illustration);

  const args = documentID
    ? {
        to: getUrlWithUTMs({ url, utms }),
        key: `horizontal-card-cta-${index}`,
        target,
      }
    : {
        href: getUrlWithUTMs({ url, utms }),
        key: `horizontal-card-cta-${index}`,
        target,
      };

  return (
    <CardCTAWrapper data-track={dataTrackAttribute} key={index} {...args}>
      <S.PictureWrapper>
        <Picture altText={alt} imageObject={image} key={index} />
      </S.PictureWrapper>
      <S.CardTitle>{cardTitle}</S.CardTitle>
      <S.CardDescription>{cardDescription}</S.CardDescription>

      <S.CardLabel>
        {label}
        <FaChevronRight />
      </S.CardLabel>
    </CardCTAWrapper>
  );
};

CardCTA.propTypes = {
  /**
   * Content of the HeaderBasic slice.
   */
  index: PropTypes.number,
  /**
   * Repeatable zone of the HorizontalCardCta.
   */
  item: PropTypes.shape({
    horizontal_card_cta_datatrack: PropTypes.string,
    horizontal_card_cta_label: PropTypes.string,
    horizontal_card_cta_link: propTypesLink,
    horizontal_card_illustration: propTypesIllustration,
    horizontal_card_title: PropTypes.string,
    horizontal_card_description: PropTypes.string,
  }),
  /**
   * Optional UTMs.
   */
  utms: PropTypes.shape(propTypesUTMs),
};
